module.exports = __webpack_public_path__ + "img/22.a564ec6d.jpg";